import { forwardRef } from 'react';
import { Search } from 'lucide-react';

/** Toolbar search field with an inset icon. */
interface LwSearchInputProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  ariaLabel?: string;
}

export const LwSearchInput = forwardRef<HTMLInputElement, LwSearchInputProps>(({
  value,
  onChange,
  placeholder,
  ariaLabel = 'Search'
}, ref) => {
  return (
    <div className="search">
      <Search size={16} />
      <input
        ref={ref}
        aria-label={ariaLabel}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
      />
    </div>
  );
});

LwSearchInput.displayName = 'LwSearchInput';
